import * as React from 'react';
import { compose } from 'redux';
import FavoriteTeams from '@om-fe/core/components/favorite-teams/favorite-teams';
import { FavoriteState, FavoriteTournaments } from '@om-fe/core/components/favorites/favorite.utils';
import BreakpointWrapper from '@om-fe/core/components/breakpoint-wrapper/breakpoint-wrapper';
import TemplateContent, { BaseTemplatePublicProps } from '@om-fe/core/core/routing/templates/template-content';
import ConnectionNotification from '@om-fe/core/components/notification/connection-notification';
import { bemContent } from '@om-fe/core/core/routing/templates/template.utils';
import { TemplateProps } from '@om-fe/core/core/routing/templates/template.models';
import { Breakpoints } from '@om-fe/core/core/store/breakpoints';
import getConfig, { OMFE2ConfigModel, CasinoFooterVersion } from '@om-fe/core/utils/config';
import { SCROLL_CONTAINER_TOP_CLASS } from '@om-fe/core/utils/dom';
import LeftSideBar from '../components/left-side-bar';
import { RightSideBarSkeleton } from '../components/right-side-bar-skeleton';
import BetslipBubble from '../components/betslip-bubble/betslip-bubble';
import { CasinoFooter } from '@om-fe/core/components/external-widgets/casino-footer';
import { BrowserOnly } from '@om-fe/widgets/dist/components/ssr/browser-only';
import { FooterTemplate } from '@om-fe/core/components/external-widgets/footer-template';
import Header from '../pages/parts/header';
import { SearchPageComponent } from '@om-fe/core/pages/theme1/search-page';
import {
    DefaultRoutesProps,
    EMRoutingContextInterface,
    RouteModel,
    RouteNames,
    customRoutePath,
    customRoutePathModel,
} from '@om-fe/core/core/routing/utils';
import withRouting from '@om-fe/core/core/routing/with-routing';
import { isBrowser } from '@om-fe/utils';
import { BetslipWrapperMobile } from '../components/betslip-wrapper/betslip-wrapper-mobile'
import RightSideBar from '../components/right-side-bar'
import { SimulateWidget } from '@om-fe/core/components/simulate/simulate-widget';

declare global {
    namespace JSX {
        interface IntrinsicElements {
            'casino-footer': any;
        }
    }
}

const config: OMFE2ConfigModel & { customConfig: { siteUrl: string, casinoFooterUrl?: string } } = getConfig();

class DefaultTemplateComponent extends React.PureComponent<TemplateProps & EMRoutingContextInterface> {
    render() {
        const { match: { url }, getRouteByUrl } = this.props;
        const routeModel: RouteModel | undefined = getRouteByUrl(url);
        const routeName: RouteNames | undefined = routeModel && routeModel.name;
        const showMobileBetslip: boolean = routeName !== RouteNames.betSlip;

        return (
            <>
                <FavoriteState />
                <FavoriteTournaments />
                <FavoriteTeams />
                <SimulateWidget />
                <BreakpointWrapper breakpoints={[Breakpoints.Large, Breakpoints.XL]}>
                    <LeftSideBar />
                </BreakpointWrapper>
                <section className={bemContent({ extra: SCROLL_CONTAINER_TOP_CLASS })}>
                    {config.enabledTopMenu && (
                        <BreakpointWrapper breakpoints={[Breakpoints.Small, Breakpoints.Medium]}>
                            <Header
                                hasSportNav={false}
                                defaultSearchMap={SearchPageComponent.defaultSearchMap}
                                searchRouteName={RouteNames.search}
                            />
                        </BreakpointWrapper>
                    )}
                    <div className={bemContent('MainArea')}>
                        <ConnectionNotification />
                        <TemplateContent {...this.props} />
                    </div>
                    {!!(config.iFrameConfig?.enableOMFEBetslipBubble) && (
                        <BreakpointWrapper breakpoints={[Breakpoints.Small]} action="show">
                            <BrowserOnly>
                                <BetslipBubble />
                            </BrowserOnly>
                        </BreakpointWrapper>
                    )}
                    {
                        config.customConfig?.casinoFooterUrl && config.customConfig?.version !== CasinoFooterVersion.V3 ? (
                            <CasinoFooter className="Footer" />
                        ) : (
                            <BrowserOnly>
                                <FooterTemplate /> 
                            </BrowserOnly>
                        )
                    }
                </section>
                {showMobileBetslip && (
                    <BrowserOnly>
                        <BreakpointWrapper breakpoints={[Breakpoints.Small]}>
                            <BetslipWrapperMobile />
                        </BreakpointWrapper>
                    </BrowserOnly>
                )}
                <BreakpointWrapper breakpoints={[Breakpoints.Small]} action="hide">
                    {isBrowser() ? <RightSideBar {...this.props} /> : <RightSideBarSkeleton />}
                </BreakpointWrapper>
            </>
        );
    }
}

export const DefaultTemplate: React.ComponentType<BaseTemplatePublicProps> = compose(
    withRouting<BaseTemplatePublicProps>(),
)(DefaultTemplateComponent);
